import { call, put, takeLatest, select, take, takeEvery} from 'redux-saga/effects'
import Cookies from 'cookies-js'
import {productOption, SAVE_DESIGN, saveDesign, PRODUCTVARIANTCOLORS, productVariantColors, SELECT_PRINT_OPTION, UPDATE_OPTION} from '../actions'
import {updateColor, updateTextValue, DEFAULTFONTS , defaultFonts,  CLIPART, clipart, CLIPART_CATEGORIES, clipartCategories, CLIPART_LIMITS, clipartLimits} from '../actions'
import { ADD_DESIGN_TO_CART, addDesignToCart, CURRENTUSER, currentUser, uploadArt, UPLOAD_ART, USER_ART, userArt, overridesApplied, USER_REGISTER, userRegister, USER_LOGIN, userLogin, USER_LOGOUT, userLogout, centerAll, CREATE_PRODUCT_VARIATION, createProductVariation, PRICE_BREAKS, pricebreaks } from '../actions'
import { DESIGN, design, copyDesign, DELETE_USER_ART, deleteUserArt} from '../actions'
import { CREATE_PRODUCT, createProduct } from '../actions'
import { productVariant, SAVE_DESIGN_RELOAD_PRICEBREAKS } from '../actions'
import findColorById from '../services/utils/findColorById'
import * as productVariationsService from '../services/ProductVariations'
import * as productOptionsService from '../services/ProductOptions'
import * as designService from '../services/design'
import * as productVariantsService from '../services/ProductVariants'
import * as productsService from '../services/Products'
import * as fontsService from '../services/fonts'
import * as clipartService from '../services/clipart'
import * as cartService from '../services/cart'
import * as userService from '../services/user'
import * as uploadService from '../services/uploads'
import * as pricebreaksService from '../services/pricebreaks'
import {API_ROOT} from '../services/api'
import {setOriginalDesignId, USER_ART_ENTITY, userArtEntity} from "../actions/index"

const getOverrideState = (state) => state.override;
const getDesignState = (state) => state.design.present;
const getCurrentColorsState = (state) => state.currentColors;
const getCopyFromState = (state) => state.copyFromDesignId;
const getUserFromState = (state) => state.user;

function* fetchEntity(entity, apiFn, id) {
  const { response, error } = yield call(apiFn, id);
  if (response) {
    yield put(entity.success(response));
  } else {
    yield put(entity.failure(error));
  }
  return response;
}

function* saveDesignToServer(action) {
  const designState = yield select(getDesignState);
  const savedByCustomer =
    action && action.payload ? action.payload.savedByCustomer : false;
  const overwrite = action && action.payload ? action.payload.overwrite : false;
  const orderItemId =
    action && action.payload ? action.payload.orderItemId : null;
  const orderNumber =
    action && action.payload ? action.payload.orderNumber : null;
  const purchasedItemID =
    action && action.payload ? action.payload.purchasedItemID : null;
  const { response, error } = yield call(
    designService.saveDesign,
    designState,
    overwrite,
    orderItemId,
    orderNumber,
    purchasedItemID,
    savedByCustomer,
  );

  if (response) {
    yield put(saveDesign.success(response));
    if (action && action.payload && action.payload.redirect) {
      window.location = action.payload.redirect;
    }
  } else {
    yield put(saveDesign.failure(error));
  }

  return response;
}

function* saveDesignThenReloadPricebreaks() {
  let response = yield saveDesignToServer();
  yield put(pricebreaks.request());
  return response;
}

function* getPricebreaks() {
  let designState = yield select(getDesignState);
  let designId = null;
  const overrides = {
    colors: [],
  };

  if (designState.id) {
    designId = designState.id;
  } else {
    yield take(DESIGN.SUCCESS);
    designState = yield select(getDesignState);
    designId = designState.id;
  }

  for (let i = 0; i < designState.layer_set.length; i++) {
    const layer = designState.layer_set[i];
    if (!layer.has_color && !layer.has_print_color) {
      continue;
    }
    if (layer.color_from_layer !== "" || layer.print_color_from_layer !== "") {
      //if we're using a color from another layer, don't include the color again
      continue;
    }

    if (layer.has_print_color) {
      overrides.colors.push({
        layer_id: layer.layer_id,
        type: "Print",
        color_id: layer.print_color.id,
        print_type: layer.print_color_type,
      });
    }

    if (layer.has_color) {
      overrides.colors.push({
        layer_id: layer.layer_id,
        type: "Paper",
        color_id: layer.color.id,
        product_variant_id: designState.product_variant_id,
      });
    }
  }

  yield fetchEntity(
    pricebreaks,
    pricebreaksService.fetchPricebreaks.bind(null, designId, overrides),
  );
}

function* loadProductVariantColors(action) {
  let entity = null,
    apiFn = null;
  if (action.payload.type === "Paper") {
    entity = productVariantColors;
    apiFn = productVariantsService.fetchPaperColors.bind(
      null,
      action.payload.layer_id,
      action.payload.product_variant_id,
      action.payload.is_cutout,
      action.payload.is_foldable,
      action.payload.is_two_sided,
    );
  } else if (action.payload.type === "Layer") {
    entity = productVariantColors;
    apiFn = productOptionsService.fetchLayerColors.bind(
      null,
      action.payload.layer_id,
      action.payload.product_option_id,
    );
  } else if (action.payload.type === "Supporting") {
    entity = productVariantColors;
    apiFn = productOptionsService.fetchSupportingColors.bind(
      null,
      action.payload.layer_id,
      action.payload.product_option_id,
    );
  } else {
    entity = productVariantColors;
    apiFn = productVariantsService.fetchPrintColors.bind(
      null,
      action.payload.layer_id,
      action.payload.product_variant_id,
      action.payload.print_type,
    );
  }

  const { response, error } = yield call(apiFn);
  if (response) {
    response.request_payload = action.payload;
    yield put(entity.success(response));
  } else {
    yield put(entity.failure(error));
  }
  return response;
}

function checkRecentColors(state, actionType) {
  // Check if product option has already been selected, and colors already fetched
  const actionString = JSON.stringify(actionType);

  for (let object of state.productOptionPayloads) {
    const objectString = JSON.stringify(object.payload);

    if (objectString === actionString) {
      return object.response;
    }
  }

  return null;
}

function* fetchColorsForLayersIfNeeded() {
  const putActions = [],
    designState = yield select(getDesignState),
    currentColorsState = yield select(getCurrentColorsState);

  for (var i = 0; i < designState.layer_set.length; i++) {
    const layer = designState.layer_set[i];
    if (!layer.has_color && !layer.has_print_color) {
      continue;
    }
    if (layer.color_from_layer !== "" || layer.print_color_from_layer !== "") {
      //if we're using a color from another layer, don't display the colors again
      continue;
    }

    if (layer.has_color) {
      if (layer.color_setting_type === "Paper") {
        const paperAction = {
          product_variant_id: designState.product_variant_id,
          layer_id: layer.layer_id,
          type: "Paper",
          is_cutout: layer.is_cutout,
          is_two_sided: layer.is_two_sided,
          is_foldable: layer.is_foldable,
        };

        const matched = checkRecentColors(currentColorsState, paperAction);

        if (matched) {
          yield put(productVariantColors.success(matched));
        } else {
          yield put(productVariantColors.request(paperAction));
          putActions.push(paperAction);
        }
      } else if (layer.color_setting_type === "Supporting") {
        const supportingAction = {
          product_variant_id: designState.product_variant_id,
          product_option_id: designState.product_option_id,
          layer_id: layer.layer_id,
          type: "Supporting",
        };

        const matched = checkRecentColors(currentColorsState, supportingAction);

        if (matched) {
          yield put(productVariantColors.success(matched));
        } else {
          yield put(productVariantColors.request(supportingAction));
          putActions.push(supportingAction);
        }
      } else {
        const layerAction = {
          product_variant_id: designState.product_variant_id,
          product_option_id: designState.product_option_id,
          layer_id: layer.layer_id,
          type: "Layer",
        };

        const matched = checkRecentColors(currentColorsState, layerAction);

        if (matched) {
          yield put(productVariantColors.success(matched));
        } else {
          yield put(productVariantColors.request(layerAction));
          putActions.push(layerAction);
        }
      }
    } else if (layer.has_print_color) {
      if (layer.print_color_type === "Paper") {
        const printPaperAction = {
          product_variant_id: designState.product_variant_id,
          layer_id: layer.layer_id,
          type: "Paper",
          is_cutout: layer.is_cutout,
          is_two_sided: layer.is_two_sided,
          is_foldable: layer.is_foldable,
        };

        const matched = checkRecentColors(currentColorsState, printPaperAction);

        if (matched) {
          yield put(productVariantColors.success(matched));
        } else {
          yield put(productVariantColors.request(printPaperAction));
          putActions.push(printPaperAction);
        }
      } else {
        const printAction = {
          product_variant_id: designState.product_variant_id,
          layer_id: layer.layer_id,
          type: "Print",
          print_type: layer.print_color_type,
        };

        const matched = checkRecentColors(currentColorsState, printAction);

        if (matched) {
          yield put(productVariantColors.success(matched));
        } else {
          yield put(productVariantColors.request(printAction));
          putActions.push(printAction);
        }
      }
    }
  }

  for (var j = 0; j < putActions.length; j++) {
    //wait until we finish loading colors
    yield take(PRODUCTVARIANTCOLORS.SUCCESS);
  }

  yield addOverridesToDesign();
}

function* loadDesign(action) {
  let response = null;

  if (action.payload.copyFromDesignId) {
    response = yield fetchEntity(
      design,
      designService.fetchCopiedDesign.bind(
        null,
        action.payload.designId,
        action.payload.copyFromDesignId,
        action.payload.nocontent,
      ),
    );
  } else {
    response = yield fetchEntity(
      design,
      designService.fetchDesign.bind(null, action.payload.designId),
    );
  }

  if (!response || typeof response.product_variant === "undefined") {
    // Redirect to homepage if design not found
    if (typeof window !== "undefined") {
      if (process.env.NODE_ENV === "production") {
        window.location.href = process.env.REACT_APP_API_ROOT;
      } else {
        alert("Could not load design");
      }
    }
    return null;
  }

  yield fetchEntity(
    productOption,
    productOptionsService.fetchProductOptionsForProductType.bind(
      null,
      response.product_variant.product_type_id,
    ),
  );

  yield fetchColorsForLayersIfNeeded();

  if (response.design.is_fyp_product) {
    yield put(setOriginalDesignId({ original_design_id: response.design.id }));
  }

  //if we're using an upsell json, save it back to the server so that we can use the id when grabbing pricebreaks on the review page
  if (action.payload.copyFromDesignId) {
    yield saveDesignToServer();
  }
}

function* loadCopyFromDesignIfNeeded() {
  const copyDesignState = yield select(getCopyFromState),
    copyId = copyDesignState.copyId ? copyDesignState.copyId : null;

  if (copyId) {
    const response = yield fetchEntity(
      copyDesign,
      designService.fetchDesign.bind(null, copyId),
    );

    if (!response || typeof response.product_variant === "undefined") {
      // Redirect to homepage if design not found
      if (typeof window !== "undefined") {
        window.location.href = process.env.REACT_APP_API_ROOT;
      }
      return null;
    }
  }
}

function* addOverridesToDesign() {
  const overrides = yield select(getOverrideState);
  const design = yield select(getDesignState);

  if (overrides.textelements) {
    for (var j = 0; j < overrides.textelements.length; j++) {
      let overrideText = overrides.textelements[j];
      yield put(
        updateTextValue({
          value: overrideText.text,
          index: overrideText.text_element_id,
          layerId: overrideText.layer_id,
        }),
      );
    }
  }

  if (overrides.colors) {
    for (var i = 0; i < overrides.colors.length; i++) {
      let overrideColor = overrides.colors[i];
      if (!overrideColor.color_id) {
        alert("One of the colors was not set");
        return;
      }
      let layer = design.layer_set.find(
        (layer) => layer.layer_id === overrideColor.layer_id,
      );
      let colors =
        overrideColor.type === "Paper" ? layer.colors : layer.print_colors;

      let foundColor = findColorById(
        colors,
        parseInt(overrideColor.color_id, 10),
      );
      if (!foundColor) {
        //TODO change this alert
        alert(
          "Could not find color id " + overrideColor.color_id + " to override",
        );
        return;
      }

      yield put(
        updateColor({
          color: foundColor,
          type: overrideColor.type,
          layerId: overrideColor.layer_id,
        }),
      );
    }
  }
  yield put(overridesApplied({}));
}

function* changedOption() {
  yield put(centerAll());
  const design = yield select(getDesignState);
  yield fetchEntity(
    productVariant,
    productVariantsService.fetchVariant.bind(null, design.product_variant_id),
  );

  yield fetchColorsForLayersIfNeeded();
}

function* handleCreateProductVariation(action) {
  const designResponse = yield saveDesignToServer();
  const data = action.payload;
  data.design_id = designResponse.id;
  const { response, error } =
    yield productVariationsService.createProductVariation(data);
  if (response) {
    yield put(createProductVariation.success(response));
  } else {
    yield put(createProductVariation.failure(error));
  }
  return response;
}

function* handleCreateProduct(action) {
  const designResponse = yield saveDesignToServer();
  const data = action.payload;
  data.design_id = designResponse.id;
  const { response, error } = yield productsService.createProduct(data);
  if (response) {
    yield put(createProduct.success(response));
  } else {
    yield put(createProduct.failure(error));
  }
  return response;
}

function* addDesignToCartAndRedirect(action) {
  const designResponse = yield saveDesignToServer();
  const result = yield fetchEntity(
    addDesignToCart,
    cartService.addToCart.bind(
      null,
      designResponse.id,
      action.payload.quantity,
      action.payload.comments,
      action.payload.largePlate,
      action.payload.proof,
      action.payload.orderId,
    ),
  );
  if (result && result.added) {
    if (action && action.payload && action.payload.redirect) {
      window.location = action.payload.redirect;
    } else {
      window.location = API_ROOT + "/cart";
    }
  } else {
    alert("There was an error. Please try again later");
  }
}

function* getUserArt() {
  const user = yield select(getUserFromState);
  yield fetchEntity(userArt, uploadService.fetchUserArt.bind(null, user.id));
}

function* fetchUserArtEntities() {
  const user = yield select(getUserFromState);
  if (user.loggedIn) {
    yield put(userArt.request());
  } else {
    const userArtIds = Cookies.get("userArtIds");
    let userArtIdsArray = userArtIds ? JSON.parse(userArtIds) : [];
    if (userArtIdsArray === null) {
      userArtIdsArray = [];
    }
    if (userArtIdsArray && userArtIdsArray.length) {
      for (let i = 0, len = userArtIdsArray.length; i < len; i++) {
        yield put(userArtEntity.request(userArtIdsArray[i]));
      }
    }
  }
}
function* deleteUserArtSuccess(action) {
  const userArtIds = Cookies.get("userArtIds");
  let userArtIdsArray = userArtIds ? JSON.parse(userArtIds) : [];
  if (userArtIdsArray === null) {
    userArtIdsArray = [];
  }
  userArtIdsArray = userArtIdsArray.filter(
    (item) => item !== action.response.userart_id,
  );
  Cookies.set("userArtIds", JSON.stringify(userArtIdsArray));

  yield fetchUserArtEntities();
}

function* uploadArtRequest(action) {
  let response = yield fetchEntity(
    uploadArt,
    uploadService.upload.bind(null, action.payload.type, action.payload.file),
  );

  const user = yield select(getUserFromState);
  if (user.loggedIn) {
    yield put(userArt.request());
  } else {
    const userArtIds = Cookies.get("userArtIds");
    let userArtIdsArray = userArtIds ? JSON.parse(userArtIds) : [];
    if (userArtIdsArray === null || !Array.isArray(userArtIdsArray)) {
      userArtIdsArray = [];
    }

    const newUserArtId = response.id;
    userArtIdsArray.push(newUserArtId);
    Cookies.set("userArtIds", JSON.stringify(userArtIdsArray));

    yield put(userArtEntity.request(newUserArtId));
  }
}

export default function* root() {
  yield [
    takeLatest(SAVE_DESIGN.REQUEST, saveDesignToServer),
    takeLatest(ADD_DESIGN_TO_CART.REQUEST, addDesignToCartAndRedirect),
    takeLatest(DESIGN.REQUEST, loadDesign),
    takeEvery(PRODUCTVARIANTCOLORS.REQUEST, loadProductVariantColors),
    takeEvery(SELECT_PRINT_OPTION, changedOption),
    takeEvery(UPDATE_OPTION, changedOption),
    takeLatest(DEFAULTFONTS.REQUEST, () => { return fetchEntity(defaultFonts, fontsService.fetchDefaultFonts) } ),
    takeLatest(CLIPART.REQUEST, () => { return fetchEntity(clipart, clipartService.fetchClipart) } ),
    takeLatest(CLIPART_CATEGORIES.REQUEST, () => { return fetchEntity(clipartCategories, clipartService.fetchClipartCategories) } ),
    takeLatest(CLIPART_LIMITS.REQUEST, () => { return fetchEntity(clipartLimits, clipartService.fetchClipartLimits) } ),
    takeLatest(CURRENTUSER.REQUEST, () => { return fetchEntity(currentUser, userService.fetchCurrentUser) } ),
    takeLatest(UPLOAD_ART.REQUEST,  uploadArtRequest),
    takeLatest(CURRENTUSER.SUCCESS, fetchUserArtEntities),
    takeLatest(USER_LOGIN.SUCCESS, fetchUserArtEntities),
    takeLatest(USER_ART.REQUEST, getUserArt),
    takeEvery(USER_ART_ENTITY.REQUEST, (action) => {
      return fetchEntity(
        userArtEntity,
        uploadService.fetchSingleUserArt.bind(null, action.payload),
      );
    }),
    takeLatest(DELETE_USER_ART.REQUEST, (action) => {
      return fetchEntity(
        deleteUserArt,
        uploadService.unpublish.bind(null, action.payload),
      );
    }),
    takeLatest(DELETE_USER_ART.SUCCESS, deleteUserArtSuccess),
    takeLatest(USER_REGISTER.REQUEST, (action) => {
      return fetchEntity(
        userRegister,
        userService.register.bind(null, action.payload),
      );
    }),
    takeLatest(USER_LOGIN.REQUEST, (action) => {
      return fetchEntity(
        userLogin,
        userService.login.bind(null, action.payload),
      );
    }),
    takeLatest(USER_LOGOUT.REQUEST, () => {
      return fetchEntity(userLogout, userService.logout);
    }),
    takeLatest(CREATE_PRODUCT_VARIATION.REQUEST, handleCreateProductVariation),
    takeLatest(CREATE_PRODUCT.REQUEST, handleCreateProduct),
    takeLatest(PRICE_BREAKS.REQUEST, getPricebreaks),
    takeLatest(DESIGN.SUCCESS, loadCopyFromDesignIfNeeded),
    takeLatest(SAVE_DESIGN_RELOAD_PRICEBREAKS, saveDesignThenReloadPricebreaks),
  ];
}
